import React from "react";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone, faLocationDot, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Industries", path: "/industries" },
    { name: "Contact", path: "/contact" },
  ];

  const services = [
    "Electroplating",
    "Anodizing",
    "Custom Finishes",
    "Restoration",
  ];

  return (
    <footer className="footer-modern">
      <div className="footer-main">
        <Container>
          <Row className="gy-5">
            <Col lg={4} md={6}>
              <div className="footer-brand">
                <h3 className="footer-logo">ElectroplatingLB</h3>
                <p className="footer-tagline">
                  Transforming metals into masterpieces since 1998. Your trusted partner for premium electroplating and metal finishing solutions.
                </p>
                <div className="footer-social">
                  <a
                    href="mailto:ralphkamel.rk@gmail.com"
                    className="social-link"
                    aria-label="Email us"
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                  </a>
                  <a
                    href="https://wa.me/96103518323"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="WhatsApp"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                  <a
                    href="https://instagram.com/electro.plating.lb"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="Follow us on Instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </div>
              </div>
            </Col>

            <Col lg={2} md={6}>
              <div className="footer-links">
                <h5 className="footer-title">Quick Links</h5>
                <ul className="footer-list">
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path} className="footer-link">
                        <FontAwesomeIcon icon={faArrowRight} className="link-icon" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={3} md={6}>
              <div className="footer-links">
                <h5 className="footer-title">Services</h5>
                <ul className="footer-list">
                  {services.map((service, index) => (
                    <li key={index}>
                      <Link to="/services" className="footer-link">
                        <FontAwesomeIcon icon={faArrowRight} className="link-icon" />
                        {service}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={3} md={6}>
              <div className="footer-contact">
                <h5 className="footer-title">Contact Info</h5>
                <div className="contact-items">
                  <div className="contact-item">
                    <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                    <a href="tel:+96103518323">+961 03 518 323</a>
                  </div>
                  <div className="contact-item">
                    <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                    <a href="mailto:ralphkamel.rk@gmail.com">ralphkamel.rk@gmail.com</a>
                  </div>
                  <div className="contact-item">
                    <FontAwesomeIcon icon={faLocationDot} className="contact-icon" />
                    <span>54 Industrial Drive, Zouk, Lebanon</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom">
        <Container>
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {currentYear} ElectroplatingLB. All rights reserved.
            </p>
            <p className="footer-developer">
              Developed by{" "}
              <a
                href="https://yourchameleon.com"
                target="_blank"
                rel="noopener noreferrer"
                className="developer-link"
              >
                YourChameleon.com
              </a>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
